import React from "react";
import "./Projects.scss";
import { images } from "../../constants";
import { motion } from "framer-motion";

const scaleVariants = {
  whileInView: {
    scale: [0, 1],
    opacity: [0, 1],
    transition: {
      duration: 1,
      ease: "easeInOut",
    },
  },
};

const Projects = () => {
  return (
    <div className="projects__container" id="projects">
      <div className="work__wrapper">
        <motion.div
          whileInView={{ x: [-100, 0], opacity: [0, 1] }}
          transition={{ duration: 0.5 }}
          className="headline__wrapper"
        >
          <p className="projects__headline">Projects</p>
          <p className="projects__description">
            Check out some of my recent work (visit my GitHub profile for more):
          </p>
        </motion.div>

        <motion.div
          variants={scaleVariants}
          whileInView={scaleVariants.whileInView}
          className="images__container"
        >
          <img src={images.project1} alt="one" className="img" />
          <img src={images.project3} alt="two" className="img" />
          <img src={images.project4} alt="three" className="img" />
          <img src={images.project2} alt="six" className="img" />
        </motion.div>
      </div>
    </div>
  );
};

export default Projects;
